export default "__VITE_ASSET__DL9N0kry__"